import { ServiceOrderStatus } from "services/serviceOrders/restModels";

export type BranchDetailsTab = "tariff" | "payments" | "accounts" | "features" | "partner";

export const TABS: { key: BranchDetailsTab; label: string }[] = [
    { key: "tariff", label: "Тариф" },
    { key: "payments", label: "История оплат" },
    { key: "accounts", label: "Аккаунты" },
    { key: "features", label: "Функции" },
    { key: "partner", label: "Партнёр" },
];

export const PARTNER_ROLE_TABS: BranchDetailsTab[] = ["tariff", "payments"];

export const SERVICE_ORDER_STATUS_LABELS: Record<ServiceOrderStatus, string> = {
    New: "Не оплачен",
    Paid: "Оплачен",
    Cancelled: "Отменён",
    Error: "Ошибка",
};

export const SERVICE_ORDER_STATUS_TONES = {
    Paid: "success",
    New: "warning",
    Cancelled: "warning",
    Error: "danger",
} as const;

export const SERVICE_ORDER_TYPE_LABELS = {
    Card: "Карта",
    Invoice: "Счёт",
};
